import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Code property - Definition */
export class DocsBlockCodePropertyDefinition extends DocsBlockPropertyDefinition {
}
